import AsyncStorage from "@react-native-async-storage/async-storage";
import { Platform } from "react-native";

const MICROPHONE_PREFERENCE_KEY = "selected_microphone_device_id";

export const saveMicrophonePreference = async (deviceId: string) => {
  try {
    await AsyncStorage.setItem(MICROPHONE_PREFERENCE_KEY, deviceId);
  } catch (error) {
    console.error("Error saving microphone preference:", error);
  }
};

export const getMicrophonePreference = async (): Promise<string | null> => {
  try {
    return await AsyncStorage.getItem(MICROPHONE_PREFERENCE_KEY);
  } catch (error) {
    console.error("Error getting microphone preference:", error);
    return null;
  }
};

export const clearMicrophonePreference = async () => {
  try {
    await AsyncStorage.removeItem(MICROPHONE_PREFERENCE_KEY);
  } catch (error) {
    console.error("Error clearing microphone preference:", error);
  }
};

export const setSystemDefaultMicrophone = async (deviceId: string): Promise<boolean> => {
  if (Platform.OS !== "web") {
    return false;
  }

  try {
    if (!navigator.mediaDevices || !navigator.mediaDevices.getUserMedia) {
      console.error("MediaDevices API not supported");
      return false;
    }

    const stream = await navigator.mediaDevices.getUserMedia({
      audio: {
        deviceId: { exact: deviceId },
      },
    });

    stream.getTracks().forEach((track) => track.stop());

    if (navigator.mediaDevices.getUserMedia) {
      await saveMicrophonePreference(deviceId);

      return true;
    }

    return false;
  } catch (error) {
    console.error("Error setting system default microphone:", error);
    return false;
  }
};
